import React from "react";
import Storage from "./storage.service";
import Helpers from "../helpers/shared.helper";
import HTTP from "./http.service";
import User from "./user.service";
import Products from "./products.service";
import GTMService from "./gtm.service";
import Settings from "./settings.service";
import Flow from "./flow.service";
import Payments from "./payments.service";
import Translations from "./translation.service";
import OTPService from "./otp.service";
import CONSTANTS from "./constants.service";

import FirebaseAnalytics from "./analytics.service";

var Numbers = {};

Numbers.per_page = 10;

Numbers.deleteAnyInitialReservations = () => {
  const foundNumbers = Numbers.fetchNumber("1");
  return foundNumbers
    .then((numberResponse) => {
      if (numberResponse.data && numberResponse.data.numbers.length > 0) {
        let number = numberResponse.data.numbers[0];
        return Numbers.cancel(number["MSISDN"])
          .then((res) => {
            Storage.set("selected_number", null);
            Storage.set("reserved_number", null);
            // Storage.set("should_select_plan", true, true);
            Storage.clear("MNPSubmitedForm");
            Storage.clear("chose_mnp");
            Storage.set("move_to_mnp_otp", false);

            return User.fetchFlowStatus(1001);
          })
          .catch((error) => {
            Helpers.handleError(error);
          });
      }
    })
    .catch((error) => {
      Helpers.handleError(error);
    });
};

Numbers.MakeWarningModal = (labels, actions, loading = false, comp = null) => {
  let warningModal = (
    <div className="number-warning-modal">
      <div className="modal-content">
        <div className="modal-text-title">{labels.title}</div>
        <div className="modal-text-message">{labels.message}</div>
        {loading ? (
          comp
        ) : (
          <div className="modal-btns">
            <button
              id="btn_leave_number_yes"
              className="btn btn-primary"
              // onClick={() => {
              //  Numbers.deleteAnyInitialReservations();
              // }}
              onClick={() => {
                actions.mainAction();
                // Numbers.deleteAnyInitialReservations();
              }}
            >
              {labels.mainBtn}
            </button>
            <button
              className="btn btn-secondary"
              id="btn_leave_number_no"
              onClick={actions.close}
            >
              {labels.closeBtn}
            </button>
          </div>
        )}
      </div>
    </div>
  );

  return warningModal;
};

Numbers.fetchMnpOperators = () => {
  let config = {
    method: "get",
    url: "/mnp/available_operators",
  };
  return HTTP(config);
};

Numbers.checkMnpStatus = () => {
  //@Todo get mnp number from api
  let data = JSON.parse(Storage.get("mnp_info", true));
  let number = null;
  if (data) {
    number = data["mnp_number"];
  } else {
    data = Storage.get("reserved_number");
    if (data && data["MSISDN"]) {
      number = data["MSISDN"];
    }
  }

  if (number) {
    number = Helpers.getNumberWithCountryCode(number);
  }

  let config = {
    method: "get",
    url:
      "/mnp/check_status?number=" +
      number +
      "&random=" +
      Date.parse(new Date()),
  };
  return HTTP(config);
};

Numbers.requestMnpOtp = () => {
  return Numbers.getMnpOtp()
    .then((res) => {
      return res;
    })
    .catch((err) => {
      // clear stuff to go back to mnp form
      Storage.clear("move_to_mnp_otp");
      // Storage.clear("mnp_info");

      throw err;
    });
};

Numbers.getMnpOtp = () => {
  let data = JSON.parse(Storage.get("mnp_info", true));
  if (data && data["mnp_number"]) {
      let mnpData = {
        number: data["mnp_number"]
      }
      let flow_type = CONSTANTS.OTP_TYPES.MNP;
      return OTPService.requestOTP(mnpData, flow_type);
  }
};

Numbers.portInMyNumber = () => {
  Numbers.deleteAnyInitialReservations().then(() => {
    setTimeout(() => {

      const data = Storage.get("flags");
      data.chose_mnp = true;
      Storage.set("flags", data);
      Storage.set("chose_mnp", true, true);
    }, 100);
  });
};

Numbers.keepMnpRequestInfo = (form) => {

  let data = {};
  // data["otp"] = "";
  data["operator_id"] = form.operator_id.value;
  if (form.contact_number.value.trim().length) {
    data["contact_number"] =
      form.country_select.iso + "" + form.contact_number.value;
  } else {
    data["contact_number"] = Helpers.getNumberWithCountryCode(
      form.mnp_number.value
    );
  }

  data["mnp_number"] = Helpers.getNumberWithCountryCode(form.mnp_number.value);

  Storage.set("mnp_info", JSON.stringify(data), true);
};

Numbers.submitMnpRequestAndNext = (form) => {
  return new Promise((resolve) => {
    Numbers.submitMnpRequest(form)
      .then(res => {
        Storage.set("chose_mnp", false, true);
        User.fetchFlowStatus(12222);
        resolve(true)
      })
      .catch(err => {
        resolve(false)
        // Storage.clear("mnp_info");
        // Storage.clear("chose_mnp");
        Storage.clear("move_to_mnp_otp");

      });
  })
};

Numbers.submitMnpRequest = (form) => {

  let data = JSON.parse(Storage.get("mnp_info", true));
  if (data) {
    data["otp"] = form.otp.value;
  }

  let config = {
    method: "post",
    url: "/mnp/submit_request",
    data: data,
  };

  return HTTP(config);
};

Numbers.fetchNumber = (reservation_ids = "1,3,4,5", callee = "default") => {
  let config = {
    method: "get",
    url:
      "/numbers?reservation_ids=" +
      reservation_ids +
      "&random=" +
      Date.parse(new Date()),
  };
  return HTTP(config);
};

Numbers.fetchNumberByReservationType = (reservation_ids = "1") => {
  //reserv_type possbile values are: initial=1, commit=3, cancel=4, autoCancel=5, termination=8,activated=9, initialToChangeNumber=10, MNPInitial=11
  let config = {
    method: "get",
    url:
      "/numbers/reservation?reservation_types=" +
      reservation_ids +
      "&random=" +
      Date.parse(new Date()),
  };
  return HTTP(config);
};

Numbers.getNumber = (callee = "default") => {
  let number = null;
  Helpers.log("Numbers.getNumber");
  return Storage.getOrfetch("reserved_number", Numbers.fetchNumber)
    .then((response) => {
      if (response["data"]) {
        if (response["data"]["numbers"][0]) {
          number = response["data"]["numbers"][0];
          Storage.set("reserved_number", number);
        } else {
          number = null;
        }
        Storage.set("reserved_number", number);
        return number;
      } else {
        number = response;

        if (response) {
          Storage.set("reserved_number", number);
        }
        return number;
      }
    })
    .catch((error) => { });
};

Numbers.startSearch = (fragment, append = true) => {
  let page = 1;
  if (append) {
    page = Storage.get("search_page") + 1;
  }
  let vanities = Storage.get("active_search_vanity");
  if ((!vanities && vanities !== 0) || vanities === "all") {
    vanities = Object.keys(Storage.get("vanity_details")).join(",");
  }

  Storage.set("searching_for_numbers", true);
  Storage.set("appending_search_results", append);
  Storage.set("search_page", page);
  Storage.set("last_search_fragment", fragment);

  const commonRecordFirebaseEvent = ({ event_label = "", interaction_type = "", ...properties }) => {
    const event_params = {
      event_category: "onboarding_number_selection",
      event_screen: "search_number",
      event_label,
      interaction_type,
      ...properties
    }
    FirebaseAnalytics.commonFunction(event_params)
  }

  Numbers.search(fragment, vanities)
    .then((response) => {
      if (response.data) {
        let initial = Storage.get("search_numbers_result");
        let no_match = Storage.get("search_numbers_no_match");
        if (!append) {
          initial = [];
          if (response.data.is_recommended_number) {
            if (page === 1) {
              no_match = true;
            }
          } else {
            no_match = response.data.is_recommended_number;
          }
        }

        Storage.set("search_numbers_no_match", no_match);
        Storage.set("search_numbers_latest", response.data);
        Storage.set("searching_for_numbers", false);
        Storage.set(
          "search_numbers_result",
          initial.concat(response.data.numbers)
        );

        const wereNumbersFound = response?.data?.numbers?.length > 0
        commonRecordFirebaseEvent({ 
          event_label: "search_number", 
          interaction_type: wereNumbersFound ? "click" : "view",
          ...( wereNumbersFound ? {
            result_count: response?.data?.numbers?.length || 0,
            number_type: vanities
          } : {})
        })
      }
    })
    .catch((error) => {
      commonRecordFirebaseEvent({ 
        event_label: "error", 
        interaction_type: "view",
        error_code: error?.data?.code || ""
      })
      // this.setState({
      // searching: false,
      // appending: false
      // });
    });
};

Numbers.getNumberDetailsFromVanity = (number) => {
  let VanityLevel = Numbers.getVanityLevelID(number);
  let vanity_details = Storage.get("vanity_details");
  return vanity_details["" + VanityLevel];
};

Numbers.get_number_pieces = (msisdn, vanity, fragment = "", color) => {
  if (msisdn?.slice(0, 3) === "966") {
    msisdn = "0" + msisdn.substring(3, msisdn.length);
  }

  let msisdn1 = msisdn?.slice(0, 3); 
  let msisdn2 = msisdn?.slice(3, 6); 
  let msisdn3 = msisdn?.slice(6);   
  let msisdnFrom3 = msisdn?.slice(3);

  let number_html = (
    <span className={"number-pieces has-type"}>
      <span className="prefix" style={color}>{msisdn1}</span>
      {msisdn2 + " " +  msisdn3}
    </span>
  );

  if (fragment && msisdnFrom3.indexOf(fragment) !== -1) {
    let split = msisdnFrom3.split(fragment);
    number_html = [];
    number_html.push(
      <span key={"ve" + Math.random()}>
        <span className="prefix">{msisdn1}</span>
      </span>
    );
    for (let piece in split) {
      number_html.push(
        <span key={msisdnFrom3 + "1" + Math.random()}>{split[piece]}</span>
      );
      if (piece < split.length - 1) {
        number_html.push(
          <span className="highlight" key={msisdnFrom3 + "2" + Math.random()}>
            {fragment}
          </span>
        );
      }
    }
  }

  return number_html;
};

Numbers.search = (fragment, vanity_level_ids) => {
  let active_vanity_id = Numbers.getVanityId();
  let defaultVanilityIds = active_vanity_id;
  if (fragment === "." || !fragment?.length) {
    defaultVanilityIds = vanity_level_ids;
  }
  if (vanity_level_ids) {
    defaultVanilityIds = vanity_level_ids;
  }
  let data = {};
  data["per_page"] = Numbers.per_page; //* Storage.get("search_page") ;
  data["page"] = Storage.get("search_page");
  data["pattern"] = fragment;
  data["vanity_level_ids"] = defaultVanilityIds;
  let config = {
    method: "post",
    url: "/numbers/search",
    data: data,
  };

  return HTTP(config);
};

Numbers.selectNumber = (number) => {
  Helpers.log("Numbers.selectNumber()", number);
  Storage.set("selected_number", number);
};

// Get Vanities if not present in storage.
Numbers.getVanityId = async () => {
  let vanity_id = Storage.get("vainity_id");
  if (vanity_id) {
    return vanity_id;
  } else {
    let dataVanity = await Numbers.vanity_details()
    if (dataVanity["data"]) {
      let vanity_id = [];
      let vanity_details = [];
      for (let vanity of dataVanity?.data) {
        vanity["vanityPrice"] = vanity["Price"];
        if (vanity?.VanityID || vanity?.VanityID === 0) {
          vanity_id.push(vanity.VanityID)
        }
      }
      vanity_id = vanity_id?.length ? vanity_id?.sort() : vanity_id;
      vanity_details = Helpers.arrayToKeyedObject(dataVanity?.data, "VanityID");
      Storage.set("vanity_details", vanity_details)
      Storage.set("vainity_id", vanity_id.toString())
      return vanity_id.toString();
    }
    return
  }
};

Numbers.getAllVanityId = () => {
  Numbers.vanity_details().then((dataVanity) => {
    if (dataVanity["data"]) {
      let vanity_id = [];
      for (let vanity of dataVanity?.data) {
        if (vanity?.VanityID || vanity?.VanityID === 0) {
          vanity_id.push(vanity.VanityID)
        }
      }
      vanity_id = vanity_id?.length ? vanity_id?.sort() : vanity_id;
      Storage.set("vainity_id", vanity_id.toString())
      return vanity_id.toString();
    }
  })

};

Numbers.vanity_details = () => {
  let config = {
    method: "get",
    url: "/numbers/vanity_details",
  };
  return HTTP(config);
};

Numbers.storage_checks = () => {
  if (Storage.get("search_page") === null) {
    Storage.set("search_page", 1);
  }

  if (Storage.get("filter_vip") === null) {
    Storage.set("filter_vip", false);
  }

  if (Storage.get("number_search_fragment") === null) {
    Storage.set("number_search_fragment", "");
    Storage.set("last_search_fragment", "");
  }

  if (Storage.get("search_numbers_no_match") === null) {
    Storage.set("search_numbers_no_match", false);
  }

  if (Storage.get("search_numbers_result") === null) {
    Storage.set("search_numbers_result", []);
  }
};

Numbers.process_vanity_details = (data) => {
  for (let vanity of data) {
    vanity["vanityPrice"] = vanity["Price"];
  }

  let processed = Helpers.arrayToKeyedObject(data, "VanityID");
  let processed_by_price = Helpers.arrayToKeyedObject(data, "Price");

  Storage.set("vanity_details", processed);
  Storage.set("vanity_details_by_price", processed_by_price);

  let keys = Object.keys(processed);
  let all = keys.join(",");
  if (Storage.get("active_search_vanity") === null) {
    Storage.set("active_search_vanity", all);
  }
};

Numbers.unselectNumber = () => {
  Storage.set("selected_number", null);
};

Numbers.getVanityDetail = (setLoading = () => { }) => {
  setLoading(true);
  let vanity_details = Storage.get("vanity_details");
  if (vanity_details) {
    setLoading(false);
    return;
  } else {
    Numbers.vanity_details().then((dataVanity) => {
      if (dataVanity["data"]) {
        let vanity_details = [];
        for (let vanity of dataVanity?.data) {
          vanity["vanityPrice"] = vanity["Price"];
        }
        vanity_details = Helpers.arrayToKeyedObject(dataVanity?.data, "VanityID");
        Storage.set("vanity_details", vanity_details)
        setLoading(false);
        return
      }
    })
  }
};

// Numbers.reserveNumberFromParams = number => {

//  Numbers.fetchNumber("1")
//      .then(numberResponse => {
//          if (numberResponse.data && numberResponse.data.numbers.length > 0) {
//              let number = numberResponse.data.numbers[0];

//              Numbers.cancel(number["MSISDN"])
//              .then(res => {
//                  Numbers.reserveNumber(number);
//              })
//              .catch(error => {
//                  // Helpers.handleError(error);
//              });

//          } else {
//              Numbers.reserveNumber(number);
//          }
//      })
//      .catch(error => {
//          // Helpers.handleError(error);
//      });
// };

Numbers.getVanityLevelID = (number) => {
  let id =
    number?.VanityLevel || number?.VanityLevel === 0
      ? number?.VanityLevel
      : number?.VanityLevelId;
  id =
    number?.VanityLevelID || number?.VanityLevelID === 0
      ? number?.VanityLevelID
      : id;

  return id;
};

Numbers.reserveNumber = (number) => {
  Storage.set("reserving_number", true);
  Storage.set("PredefinedPlansWithVanity", null);
  Numbers.postNumber(number.MSISDN)
    .then((response) => {
      Products.saveCurrentProduct()
        .then((resp) => {
          let VanityLevel = Numbers.getVanityLevelID(number);
          if (!VanityLevel) {
            Numbers.fetchNumber("1")
              .then((numberResponse) => {
                if (
                  numberResponse["data"] &&
                  numberResponse["data"]["numbers"][0]
                ) {
                  let number = numberResponse["data"]["numbers"][0];
                  VanityLevel = Numbers.getVanityLevelID(number);

                  Storage.set("number_selected_flow_vanity_id", VanityLevel);
                  Storage.set("number_VanityLevel", VanityLevel);

                  // GTMService.action_on_book_your_number_click_on_cta();
                  if (Settings.version === "_kw_onboard")
                    Storage.set("choose_random_number", true, true);
                  User.fetchFlowStatus(12)
                    .then((resp) => {
                      Storage.clear("list_selected_number");
                      Storage.set("reserving_number", false);
                      Storage.set("reserved_number", number);
                      Storage.set("selected_number", null);
                    })
                    .catch((err) => { });
                }
              })
              .catch((err) => { });
          } else {
            let VanityLevel = Numbers.getVanityLevelID(number);
            Storage.set("number_selected_flow_vanity_id", VanityLevel);
            Storage.set("number_VanityLevel", VanityLevel);

            // GTMService.action_on_book_your_number_click_on_cta();

            if (Settings.version === "_kw_onboard")
              Storage.set("choose_random_number", true, true);

            User.fetchFlowStatus(12)
              .then((resp) => {
                Storage.clear("list_selected_number");
                Storage.set("reserving_number", false);
                Storage.set("reserved_number", number);
                Storage.set("selected_number", null);
              })
              .catch((err) => { });
          }
        })
        .catch((error) => { });
    })
    .catch((error) => {
      Storage.set("reserving_number", false);
    });
};

Numbers.postNumber = (MSISDN) => {
  Helpers.log("Numbers.postNumber()", MSISDN);

  let data = {};
  data["number"] =
    //"971" +
    MSISDN;
  //.substr(1)

  let config = {
    method: "post",
    url: "/numbers",
    data: data,
  };
  return HTTP(config);
};

Numbers.getNumberStats = () => {
  let config = {
    method: "get",
    url: "/numbers",
  };
  return HTTP(config);
};

Numbers.isPremiumNumber = (number) => {
  let details = Numbers.getNumberDetailsFromVanity(number);
  if (details["vanityPrice"] > 0) {
    return true;
  } else {
    return false;
  }
};

Numbers.cancel = (MSISDN) => {
  let data = {};
  data["number"] =
    //"0" +
    MSISDN;
  //.substr(3)

  let config = {
    method: "delete",
    url: "/numbers",
    data: data,
  };
  return HTTP(config);
};

Numbers.mnpCancel = (MSISDN) => {
  let data = {};
  data["number"] = MSISDN;
  let config = {
    method: "post",
    url: "/mnp/cancel",
    data: data,
  };
  return HTTP(config);
};

Numbers.getRandomNumber = (is_family = false) => {
  let config = {
    method: "post",
    url: "/numbers/random",
    data: {
      is_family,
    },
  };
  return HTTP(config);
};

Numbers.confirmRandomNumber = (params) => {
  let config = {
    method: "post",
    url: "/numbers/random_confirmation",
  };
  return HTTP(config);
};

Numbers.postProcessReservedNumber = (ids = "1") => {
  let f = Numbers.fetchNumber(ids);
  f.then((numberResponse) => {
    if (numberResponse["data"] && numberResponse["data"]["numbers"][0]) {
      let number = numberResponse["data"]["numbers"][0];
      let VanityLevel = Numbers.getVanityLevelID(number);
      Storage.set("number_selected_flow_vanity_id", VanityLevel);
      Storage.set("number_VanityLevel", VanityLevel);
      Storage.set("reserving_number", false);
      Storage.set("reserved_number", number);
      Storage.set("selected_number", null);
      GTMService.action_on_book_your_number_click_on_cta();
    }
  }).catch((err) => {
    // Do Nothing
  });

  return f;
};


Numbers.postProcessCommitedNumber = (ids = "2") => {
  let f = Numbers.fetchNumber(ids);
  f.then((numberResponse) => {
    if (numberResponse["data"] && numberResponse["data"]["numbers"][0]) {
      let number = numberResponse["data"]["numbers"][0];
      let VanityLevel = Numbers.getVanityLevelID(number);
      Storage.set("number_selected_flow_vanity_id", VanityLevel);
      Storage.set("number_VanityLevel", VanityLevel);
      Storage.set("reserving_number", false);
      Storage.set("get_commiting_number", false);
      Storage.set("reserved_number", null);
      Storage.set("selected_number", null);
      Storage.set("commited_number", numberResponse["data"]["numbers"][0]);
      //  GTMService.action_on_book_your_number_click_on_cta();
    }
  }).catch((err) => {
  // Do Nothing
});

  return f;
};

//use services for Kuwait
if (
  Settings.version &&
  (Settings.version === "_kuwait" || Settings.version === "_kw_onboard")
) {
  Numbers.get_number_pieces_kw = (
    msisdn,
    name,
    fragment = "",
    style_value = "",
    sub_name = "",
    price = ""
  ) => {
    // if (msisdn.slice(0, 3) === "966") {
    //     msisdn = "0" + msisdn.substring(3, msisdn.length);
    // }

    let msisdn1 = msisdn.slice(0, 3);
    // let msisdn1 = msisdn.slice(1, 3);
    let msisdn2 = msisdn.slice(3, 5);
    let msisdn3 = msisdn.slice(5);

    let number_html = (
      <span className={"number-pieces has-type"}>
        <span className="prefix">{`${msisdn1} ${msisdn2} ${msisdn3}`}</span>
        {/* <span className="prefix">{msisdn1}</span>
               < span className="prefix"> {msisdn2}</span> */}
        <span className="vanity-type">
          {name + " "}
          <span style={{ color: style_value }}>{sub_name} </span>
          {Settings.version && Settings.version === "_kw_onboard" ? (
            <span className="list-arrow-with-KD">
              <span className="number-price">
                {Translations.keys["stm_general_currency"]} {price}
              </span>
              <span className="list-arrow-kd"></span>
            </span>
          ) : (
            <span className="list-arrow"></span>
          )}
        </span>
      </span>
    );
    //bolder if match
    // if (fragment && msisdn2.indexOf(fragment) !== -1) {
    //     let split = msisdn2.split(fragment);
    //     number_html = [];
    //     number_html.push(
    //         <span key={"ve" + Math.random()}>
    //             <span className="prefix">{msisdn1}</span>
    //         </span>
    //     );
    //     for (let piece in split) {
    //         number_html.push(
    //             <span key={msisdn2 + "1" + Math.random()}>{split[piece]}</span>
    //         );
    //         if (piece < split.length - 1) {
    //             number_html.push(
    //                 <span className="highlight" key={msisdn2 + "2" + Math.random()}>
    //                     {fragment}
    //                 </span>
    //             );
    //         }
    //     }
    //     return <div>{number_html}</div>
    // }

    return number_html;
  };

  Numbers.getNumberPartKW = (number) => {
    if ((number + "").length === 11)
      return " " + number.slice(3, 5) + "" + number.slice(5);
    if ((number + "").length === 8)
      return " " + number.slice(0, 2) + "" + number.slice(2);
    if ((number + "").length === 9)
      return " " + number.slice(1, 3) + "" + number.slice(3);

    return number;
  };

  Numbers.getNumberPiecesOnlyKw = (number) => {
    let msisdn1 = number.slice(1, 3); // temporary
    let msisdn2 = number.slice(3, 5);
    let msisdn3 = number.slice(5);
    return `${msisdn1} ${msisdn2} ${msisdn3}`;
  };

  Numbers.getPlansFromVanityNumberKw = (number) => {
    let plan = Numbers.getNumberDetailsFromVanity(number);
    let plan_specs = {};
    let plan_list = plan["Plan"] ? plan["Plan"] : plan["Plans"];
    if (plan.Commitment !== "") {
      if (+plan.Commitment > 12) {
        plan["CommitmentUnitKey"] = "general_time_year";
        plan["CommitmentDuration"] = +plan.Commitment / 12;
      } else {
        plan["CommitmentUnitKey"] = "general_time_month";
        plan["CommitmentDuration"] = plan.Commitment;
      }
    } else {
      plan["CommitmentUnitKey"] = false;
    }

    if (plan_list.length) {
      for (let plan_spec of plan_list) {
        if (plan_spec.Type === "DATA") {
          // if (!plan["is_vanity_plan"]) {
          //     plan_spec["Formatted"] = Helpers.bytesToGBs(plan_spec.Value);
          // } else {
          plan_spec["Formatted"] = plan_spec.Value;
          // }

          plan_spec["FormattedUnit"] = "GB";
          plan_spec["FormattedUnitLokaliseKey"] = "general_plan_units_gb";
          plan_spec["FormattedLokaliseData"] = "scr_2.0_A_data";
        }

        if (plan_spec.Type === "VOICE-LCL") {
          // if (!plan["is_vanity_plan"]) {
          //     plan_spec["Formatted"] = Helpers.milisecondstoMinutes(
          //         plan_spec.Value
          //     );
          // } else {
          plan_spec["Formatted"] = plan_spec.Value;
          // }

          // let extra = 0;

          // if (result && result.extraLocalFormatted) {
          //     extra = result.extraLocalFormatted;
          // }

          // plan_spec["extra"] = extra;
          // plan["extraLocalFormatted"] = extra;

          plan_spec["FormattedUnit"] = "min";
          plan_spec["FormattedUnitLokaliseKey"] =
            "general_plan_units_minute_short";
          plan_spec["FormattedLocalLokaliseKey"] = "kw_general_plan_local";
        }

        if (plan_spec.Type === "VOICE-INT") {
          // if (!plan["is_vanity_plan"]) {
          //     plan_spec["Formatted"] = Helpers.milisecondstoMinutes(
          //         plan_spec.Value
          //     );
          // } else {
          plan_spec["Formatted"] = plan_spec.Value;
          // }

          // let extra = 0;

          // if (result && result.extraInternationalFormatted) {
          //     extra = result.extraInternationalFormatted;
          // }

          // plan_spec["extra"] = extra;
          // plan["extraInternationalFormatted"] = extra;

          plan_spec["FormattedUnit"] = "min";
          plan_spec["FormattedInternaionalLokaliseKey"] =
            "kw_general_plan_international";
          plan_spec["FormattedUnitLokaliseKey"] = "general_min_sms";
        }

        plan_specs[plan_spec.Type] = plan_spec;
      }

      // plan["subplans"] = subplans.sort(Helpers.sortDefault);

      // plan['save_percentage'] = (promotions) && )

      //plan["OriginalPrice"] !== plan["DiscountedPrice"]? plan["DiscountedPrice"] / plan["OriginalPrice"] * 100: 0;

      // if (plan["IsPopular"]) {
      //     Storage.set("popular_plan_id", plan["ID"]);
      // }
    }
    plan["specs"] = plan_specs;
    return plan;
  };

  Numbers.fetchNumberKW = (ids = "1") => {
    let f = Numbers.fetchNumber(ids);
    f.then((numberResponse) => {
      if (numberResponse["data"] && numberResponse["data"]["numbers"][0]) {
        let number = numberResponse["data"]["numbers"][0];
        let VanityLevel = Numbers.getVanityLevelID(number);
        Storage.set("number_selected_flow_vanity_id", VanityLevel);
        Storage.set("number_VanityLevel", VanityLevel);
        Storage.set("reserving_number", false);
        Storage.set("reserved_number", number);
        Storage.set("selected_number", numberResponse["data"]["numbers"][0]);
        // GTMService.action_on_book_your_number_click_on_cta();
      }
    }).catch((err) => { });
  };

  Numbers.reserveInitialNumberWithoutCheckKW = (MSISDN) => {
    let data = {};
    data["number"] =
      //"0" +
      MSISDN;
    //.substr(3)

    let config = {
      method: "post",
      url: "/numbers/reserve_number_without_check",
      data: data,
    };
    return HTTP(config);
  };
  Numbers.checkInitialNumberAndReserveWithoutCheck = () => {
    let number = null;
    Helpers.log("Numbers.getNumber");
    return Numbers.fetchNumber()
      .then((response) => {
        if (response["data"]) {
          if (response["data"]["numbers"][0]) {
            number = response["data"]["numbers"][0];
            Storage.set("reserved_number", number);
            return Numbers.reserveInitialNumberWithoutCheckKW(number.MSISDN);
          } else {
            number = null;
          }
          Storage.set("reserved_number", number);
          return number;
        } else {
          number = response;

          if (response) {
            Storage.set("reserved_number", number);
            return Numbers.reserveInitialNumberWithoutCheckKW(number.MSISDN);
          }
          return number;
        }
      })
      .catch((error) => { });
  };

  Numbers.fetchNumberAndConfirmNon3d = () => {
    return Numbers.fetchNumber("1", "1")
      .then((res) => {
        let number = res.data["numbers"][0];

        if (number && number["BookingCode"]) {
          let booking_code = number["BookingCode"];

          Helpers.log("booking_code = " + booking_code);
          let confirmData = null;
          let tap_data = null;
          try {
            let order_id_obj = JSON.parse(
              window.localStorage.getItem("order_id")
            );

            let status_obj = JSON.parse(window.localStorage.getItem("status"));

            let tap_data_obj = JSON.parse(
              window.localStorage.getItem("tap_data")
            );
            let order_id = order_id_obj[Storage.get("session")];
            let status = status_obj[Storage.get("session")];
            tap_data = tap_data_obj[Storage.get("session")];
            confirmData = {
              order_id: order_id,
              status: status,
            };
          } catch (error) {
            Storage.set("payment_error", true);
            Payments.actionClearPaymentStorage();
            Flow.goTo();
          }

          Payments.confirmOnlinePaymentKw(confirmData)
            .then((response) => {
              if (response && response.data === 201) {
                let commitNumberData = {
                  alias: tap_data.id,
                  customer_name: tap_data.card.name,
                  booking_code: booking_code,
                };
                Payments.confirmNon3d(commitNumberData)
                  .then((response) => {
                    if (response && response.data && response.status === 201) {
                      User.fetchFlowStatus(7)
                        .then((res) => {
                          Flow.goTo();
                        })
                        .catch((error) => { });
                    } else {
                      Storage.set("payment_error", true);
                      Payments.actionClearPaymentStorage();
                      Flow.goTo();
                    }
                  })
                  .catch((error) => {
                    Storage.set("payment_error", true);
                    Payments.actionClearPaymentStorage();
                    Flow.goTo();
                  });
              } else {
                Storage.set("payment_error", true);
                Payments.actionClearPaymentStorage();
                Flow.goTo();
              }
            })
            .catch((error) => {
              Storage.set("payment_error", true);
              Payments.actionClearPaymentStorage();
              Flow.goTo();
            });
        } else {
          // no number
          Helpers.log("no number");
          Payments.actionClearPaymentStorage();
          // GTMService.action_on_payment_failed();
          Storage.set("payment_error", true);
          Flow.goTo();
          // this.setState({ error: true })
        }
      })
      .catch((error) => {
        // Errors.handleError(error);
        Storage.set("payment_error", true);
        Payments.actionClearPaymentStorage();
        Flow.goTo();
      });
  };

  //use services for Kuwait
  if (Settings.version && Settings.version === "_kw_onboard") {
    Numbers.getRandomNumberInitial = () => {
      Storage.set("randomErrorStatus", true, true);
      Numbers.getRandomNumber()
        .then((numberResponse) => {
          Storage.clear("randomErrorStatus");
          if (numberResponse["data"] && numberResponse.data) {
            let number = numberResponse["data"];
            let VanityLevel = Numbers.getVanityLevelID(number);
            Storage.set("number_selected_flow_vanity_id", VanityLevel);
            Storage.set("number_VanityLevel", VanityLevel);
            Storage.set("get_commiting_number", false);
            Storage.set("reserved_number", null);
            Storage.set("selected_number", null);
            Storage.set("random_number", number);
            //  GTMService.action_on_book_your_number_click_on_cta();
          }
        })
        .catch((err) => {
        // Do Nothing
      });
    };
    Numbers.checkMnpStatusKW = (number) => {
      //@Todo get mnp number from api
      let config = {
        method: "get",
        url: "/mnp/number_details",
        params: {
          number: number,
        },
      };
      Storage.set("checking_mnp_kw", true);
      return HTTP(config);
    };
    Numbers.confirmMNP = (data) => {
      //@Todo get mnp number from api
      let config = {
        method: "post",
        url: "/mnp/submit_request",
        data,
      };

      return HTTP(config);
    };
    Numbers.validateMNPOTP = (data) => {
      let config = {
        method: "get",
        url: `mnp/mnp_outstanding?number=${data.number}&otp=${data.otp}`,
        data,
      };

      return HTTP(config);
    };
  }
}
export default Numbers;